import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';

export const SidebarDataClient = [

    {
        title: 'Home',
        path: '/customer-details',
        icon: <IoIcons.IoIosPaper />,
        cName: 'nav-text'
    },
  {
        title: 'Applications',
        path: '/applications-list',
        icon: <AiIcons.AiOutlineAccountBook />,
        cName: 'nav-text'
    }, 
    {
        title: 'Application Status',
        path: '/application-status',
        icon: <FaIcons.FaEnvelopeOpenText />,
        cName: 'nav-text'
    },

    {
        title: 'Chalani',
        path: '/chalani',
        icon: <IoIcons.IoIosPaper />,
        cName: 'nav-text'
    },
    {
        title: 'Progress Report',
        path: '/progress-report',
        icon: <IoIcons.IoIosPaper />,
        cName: 'nav-text'
    },
   
    // {
    //     title: 'Support',
    //     path: '/support',
    //     icon: <IoIcons.IoMdHelpCircle />,
    //     cName: 'nav-text'
    // }
];